import {
  grpcCodeExampleTemplate,
  urlPlaceholder,
  xTokenPlaceholder,
} from '../constants';

export const getGRPCCodeExample = (xToken: string, url: string) =>
  grpcCodeExampleTemplate
    .replace(xTokenPlaceholder, xToken)
    .replace(urlPlaceholder, url);
